import React from "react";
import { ProductConsumer } from "../../Context/AddProWakel";

const MODEL_OPTIONS = [
    { value: "", label: "هەمو" },
    { value: "Product", label: "کاڵا" },
    { value: "ProductTable", label: "تێبلی کاڵا" },
    { value: "Sale", label: "فرۆشتن" },
    { value: "Buy", label: "کڕین" },
    { value: "Broken", label: "شکان" },
    { value: "Wakil", label: "وەکیل" },
    { value: "Para", label: "پارە" },
    { value: "Pardan", label: "پارەدان" },
    { value: "Mandwb", label: "مەندوب" },
    { value: "Garanawa", label: "گەڕانەوە" },
    { value: "Masrwfat", label: "مەسروفات" },
    { value: "Apeopple", label: "کەس" },
    { value: "Paradarhenan", label: "پارەدەرهێنان" },
    { value: "Parawargrtn", label: "پارەوەرگرتن" },
    { value: "Paraybardast", label: "پارەی بەردەست" },
    { value: "ParaGorinawa", label: "پارە گۆڕینەوە" },
    { value: "User", label: "بەکارهێنەر" },
    { value: "Rent", label: "کرێ" },
    { value: "TesxtOnBord", label: "قەرزی دەفتەر" },
    { value: "Setting", label: "ڕێکخستن" },
];

const FillDetailAuditLog = () => {
    return (
        <ProductConsumer>
            {(value) => {
                const {
                    AL_from,
                    AL_to,
                    AL_action,
                    AL_model,
                    AL_page,
                    AL_pages,
                    AL_total,
                    AL_applyFilter,
                    AL_pageplusone,
                    AL_pageminsone,
                    AddProChange,
                } = value;
                return (
                    <div className="row py-2" style={{ backgroundColor: "#2C3539" }}>
                        {/* Title */}
                        <div className="col-lg-2 col-12 text-right mt-1">
                            <h5 className="font-weight-bold text-warning">
                                <i className="fas fa-history mx-1"></i>
                                ژوورنالی تبدیلات
                            </h5>
                        </div>

                        {/* Model Filter */}
                        <div className="col-lg-2 col-6">
                            <select
                                name="AL_model"
                                value={AL_model}
                                onChange={AddProChange}
                                className="form-control form-control-sm"
                                style={{
                                    backgroundColor: "#1f1f1f",
                                    color: "#e0e0e0",
                                    border: "1px solid #555",
                                }}
                            >
                                {MODEL_OPTIONS.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Action Filter */}
                        <div className="col-lg-1 col-6">
                            <select
                                name="AL_action"
                                value={AL_action}
                                onChange={AddProChange}
                                className="form-control form-control-sm"
                                style={{
                                    backgroundColor: "#1f1f1f",
                                    color: "#e0e0e0",
                                    border: "1px solid #555",
                                }}
                            >
                                <option value="">هەمو</option>
                                <option value="UPDATE">UPDATE</option>
                                <option value="DELETE">DELETE</option>
                            </select>
                        </div>

                        {/* Date From */}
                        <div className="col-lg-2 col-6">
                            <div className="input-group input-group-sm">
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        style={{
                                            backgroundColor: "#343a40",
                                            color: "#ffc107",
                                            border: "1px solid #555",
                                        }}
                                    >
                                        لە
                                    </span>
                                </div>
                                <input
                                    type="date"
                                    name="AL_from"
                                    value={AL_from}
                                    onChange={AddProChange}
                                    className="form-control form-control-sm"
                                    style={{
                                        backgroundColor: "#1f1f1f",
                                        color: "#e0e0e0",
                                        border: "1px solid #555",
                                    }}
                                />
                            </div>
                        </div>

                        {/* Date To */}
                        <div className="col-lg-2 col-6">
                            <div className="input-group input-group-sm">
                                <div className="input-group-prepend">
                                    <span
                                        className="input-group-text"
                                        style={{
                                            backgroundColor: "#343a40",
                                            color: "#ffc107",
                                            border: "1px solid #555",
                                        }}
                                    >
                                        تا
                                    </span>
                                </div>
                                <input
                                    type="date"
                                    name="AL_to"
                                    value={AL_to}
                                    onChange={AddProChange}
                                    className="form-control form-control-sm"
                                    style={{
                                        backgroundColor: "#1f1f1f",
                                        color: "#e0e0e0",
                                        border: "1px solid #555",
                                    }}
                                />
                            </div>
                        </div>

                        {/* Search Button */}
                        <div className="col-lg-1 col-4">
                            <button
                                className="btn btn-sm btn-warning btn-block"
                                onClick={AL_applyFilter}
                            >
                                <i className="fas fa-search"></i> بگەڕە
                            </button>
                        </div>

                        {/* Pagination */}
                        <div className="col-lg-2 col-8 d-flex align-items-center justify-content-end">
                            <span
                                className="text-muted mx-2"
                                style={{ fontSize: "0.8rem" }}
                            >
                                کۆ: {AL_total}
                            </span>
                            <button
                                className="btn btn-sm btn-outline-warning mx-1"
                                onClick={AL_pageminsone}
                                disabled={AL_page <= 1}
                            >
                                <i className="fas fa-chevron-right"></i>
                            </button>
                            <span className="text-warning mx-1" style={{ fontSize: "0.85rem" }}>
                                {AL_page} / {AL_pages}
                            </span>
                            <button
                                className="btn btn-sm btn-outline-warning mx-1"
                                onClick={AL_pageplusone}
                                disabled={AL_page >= AL_pages}
                            >
                                <i className="fas fa-chevron-left"></i>
                            </button>
                        </div>
                    </div>
                );
            }}
        </ProductConsumer>
    );
};

export default FillDetailAuditLog;
